import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import useStyles from './styles';
export default function Carousel(_ref) {
  let list = _ref.list,
    nextArrowButton = _ref.nextArrowButton,
    prevArrowButton = _ref.prevArrowButton;
  const classes = useStyles();
  const settings = {
    speed: 300,
    fade: true,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    nextArrow: nextArrowButton,
    prevArrow: prevArrowButton
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.sliderWrapper
  }, /*#__PURE__*/React.createElement(Slider, settings, list));
}